class StoreBrands {
  constructor() {
    this.brandsContainer = document.querySelector('.js-store-brands');
    this.brandItems = document.querySelectorAll('.js-store-brand');
    this.searchInput = document.querySelector('.vendor__search input[type="search"]');
    this.filterButtons = document.querySelectorAll('.store__filter-btn');
    this.brandLinks = document.querySelectorAll('.store__brand a');
    this.letterButtons = document.querySelectorAll('.js-store-brands-letter');
    this.originalUrls = new Map();
    this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.isZebFr = window.location.hostname.includes('zeb.fr');

    if (this.brandsContainer && this.brandItems.length) {
      this.noResultsEl = document.createElement('div');
      this.noResultsEl.className = 'store__brands-no-results';
      this.noResultsEl.textContent = window.theme.strings.no_brands_found;
      this.noResultsEl.style.display = 'none';
      this.brandsContainer.appendChild(this.noResultsEl);

      this.storeOriginalUrls();
      this.init();
      this.initSearch();
      this.initFilters();
      this.initLetterFilter();

      window.addEventListener('resize', () => {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
      });
    }
  }

  buildCollectionUrl(handle) {
    if (this.isZebFr) {
      return `/collections/${handle}`;
    }

    return `${window.Shopify.locale === 'nl' ? '' : `/${window.Shopify.locale}`}/collections/${handle}`;
  }

  storeOriginalUrls() {
    this.brandLinks.forEach((link) => {
      const brand = link.closest('.store__brand');
      this.originalUrls.set(brand, link.href);
    });
  }

  init() {
    const groupedBrands = {};
    const seenUrls = new Set();

    this.brandItems.forEach((brand) => {
      const link = brand.querySelector('a');
      if (!link) return;

      const url = link.href;
      if (seenUrls.has(url)) {
        brand.remove();
        return;
      }
      seenUrls.add(url);

      const firstChar = brand.dataset.firstLetter;
      const groupKey = /[0-9]/.test(firstChar) ? '#' : firstChar;
      if (!groupedBrands[groupKey]) {
        groupedBrands[groupKey] = [];
      }
      groupedBrands[groupKey].push(brand);
    });

    const noResults = this.noResultsEl;

    this.brandsContainer.innerHTML = '';
    this.brandsContainer.appendChild(noResults);

    Object.keys(groupedBrands)
      .sort((a, b) => {
        if (a === '#') return -1;
        if (b === '#') return 1;
        return a.localeCompare(b);
      })
      .forEach((key) => {
        const letterGroup = document.createElement('div');
        letterGroup.className = 'store__brands-letter-group';

        const letterHeading = document.createElement('h3');
        letterHeading.className = 'store__brands-letter';
        letterHeading.textContent = key;

        const brandsWrapper = document.createElement('div');
        brandsWrapper.className = 'store__brands-letter-items';

        groupedBrands[key].forEach((brand) => {
          brandsWrapper.appendChild(brand);
        });

        letterGroup.appendChild(letterHeading);
        letterGroup.appendChild(brandsWrapper);
        this.brandsContainer.appendChild(letterGroup);
      });

    this.brandLinks = document.querySelectorAll('.store__brand a');
  }

  initSearch() {
    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', () => {
      const searchText = this.searchInput.value.toLowerCase();
      const letterGroups = this.brandsContainer.querySelectorAll('.store__brands-letter-group');

      letterGroups.forEach((group) => {
        const brands = group.querySelectorAll('.js-store-brand');
        let visibleBrands = 0;

        brands.forEach((brand) => {
          const brandText = brand.textContent.toLowerCase();
          if (brandText.includes(searchText)) {
            brand.style.display = '';
            visibleBrands++;
          } else {
            brand.style.display = 'none';
          }
        });

        group.style.display = visibleBrands > 0 ? '' : 'none';
      });

      this.checkVisibleBrands();
      this.updateAvailableLetters();
    });
  }

  checkVisibleBrands() {
    const visibleBrands = Array.from(document.querySelectorAll('.js-store-brand')).filter(
      (brand) => brand.style.display !== 'none',
    ).length;
    this.noResultsEl.style.display = visibleBrands === 0 ? '' : 'none';

    const letterGroups = this.brandsContainer.querySelectorAll('.store__brands-letter-group');
    letterGroups.forEach((group) => {
      const visibleInGroup = Array.from(group.querySelectorAll('.js-store-brand')).filter(
        (brand) => brand.style.display !== 'none',
      ).length;
      group.style.display = visibleInGroup === 0 ? 'none' : '';
    });
  }

  applyFilter(filterType, shouldScroll = false) {
    this.brandLinks.forEach((link) => {
      const brand = link.closest('.store__brand');

      switch (filterType) {
        case 'men': {
          const menCollection = brand.dataset.collectionMen;
          if (menCollection && menCollection !== '') {
            link.href = this.buildCollectionUrl(menCollection);
            brand.style.display = '';
          } else {
            brand.style.display = 'none';
          }
          break;
        }

        case 'women': {
          const womenCollection = brand.dataset.collectionWomen;
          if (womenCollection && womenCollection !== '') {
            link.href = this.buildCollectionUrl(womenCollection);
            brand.style.display = '';
          } else {
            brand.style.display = 'none';
          }
          break;
        }

        default: {
          brand.style.display = '';
          if (this.originalUrls.has(brand)) {
            link.href = this.originalUrls.get(brand);
          }
        }
      }
    });

    this.checkVisibleBrands();
    this.updateAvailableLetters();

    if (shouldScroll && this.isMobile) {
      const letterGroup = document.querySelector('.js-store-brands-letter-group');
      if (letterGroup) {
        setTimeout(() => {
          const header = document.querySelector('.page-header');
          const headerHeight = header ? header.offsetHeight : 0;
          const offset = headerHeight + 20;
          const elementPosition = letterGroup.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
          });
        }, 100);
      }
    }
  }

  initFilters() {
    let savedFilter = localStorage.getItem('selectedFilter') || 'all';

    const path = window.location.pathname;
    if (path.includes('merken-heren') || path.includes('marques-homme')) {
      savedFilter = 'men';
    } else if (path.includes('merken-dames') || path.includes('marques-femme')) {
      savedFilter = 'women';
    }

    this.filterButtons.forEach((btn) => {
      if (btn.dataset.filter === savedFilter) {
        btn.classList.add('button--square-active');
      } else {
        btn.classList.remove('button--square-active');
      }
    });

    this.applyFilter(savedFilter, false);

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filterType = button.dataset.filter;

        localStorage.setItem('selectedFilter', filterType);

        this.filterButtons.forEach((btn) => {
          btn.classList.remove('button--square-active');
        });

        button.classList.add('button--square-active');

        this.applyFilter(filterType, true);
      });
    });
  }

  initLetterFilter() {
    if (!this.letterButtons.length) return;

    this.updateAvailableLetters();

    this.letterButtons.forEach((letter) => {
      letter.addEventListener('click', () => {
        if (letter.classList.contains('is-disabled')) return;

        const selectedLetter = letter.dataset.letter.toUpperCase();
        const activeFilterButton = document.querySelector('.store__filter-btn.button--square-active');
        const activeFilter = activeFilterButton?.dataset.filter || 'all';

        if (letter.classList.contains('is-active')) {
          letter.classList.remove('is-active');
          this.applyFilter(activeFilter);
        } else {
          this.letterButtons.forEach((btn) => btn.classList.remove('is-active'));
          letter.classList.add('is-active');

          this.brandItems.forEach((brand) => {
            const brandLetter = brand.dataset.firstLetter;
            const shouldShowByLetter =
              selectedLetter === '#' ? /[0-9]/.test(brandLetter) : brandLetter === selectedLetter;

            let shouldShowByGender = true;
            if (activeFilter === 'women') {
              shouldShowByGender =
                brand.dataset.collectionWomen && brand.dataset.collectionWomen !== '';
            } else if (activeFilter === 'men') {
              shouldShowByGender =
                brand.dataset.collectionMen && brand.dataset.collectionMen !== '';
            }

            brand.style.display = shouldShowByLetter && shouldShowByGender ? '' : 'none';
          });

          if (this.isMobile) {
            const storeBrandsSection = document.querySelector('.store__brands');
            if (storeBrandsSection) {
              setTimeout(() => {
                const header = document.querySelector('.page-header');
                const headerHeight = header ? header.offsetHeight : 0;
                const offset = headerHeight + 20;
                const elementPosition =
                  storeBrandsSection.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: elementPosition - offset,
                  behavior: 'smooth',
                });
              }, 100);
            }
          }
        }

        this.checkVisibleBrands();
      });
    });
  }

  updateAvailableLetters() {
    const visibleBrands = Array.from(this.brandItems).filter(
      (brand) => brand.style.display !== 'none',
    );

    const availableLetters = new Set(
      visibleBrands.map((brand) => {
        const firstChar = brand.dataset.firstLetter.toLowerCase();
        return /[0-9]/.test(firstChar) ? '#' : firstChar;
      }),
    );

    this.letterButtons.forEach((letter) => {
      const letterValue = letter.dataset.letter.toLowerCase();
      if (availableLetters.has(letterValue)) {
        letter.classList.remove('is-disabled');
      } else {
        letter.classList.add('is-disabled');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new StoreBrands();
});
